import {
    BackendSchema,
    RuleSchema,
    RuleType,
    GetRuleCompany, Rule, RuleSchemaType, CheckboxOptions,
} from "layouts/charging-rules/interface/Rules.ts"

export function customEqual(rules: Rule[], schema: RuleSchemaType): boolean {
    for (const rule of rules) {
        const schemaValue = schema[rule.type];
        if (rule.kind === 'checkbox') {
            const checkboxOptions = schemaValue as CheckboxOptions;
            if (!checkboxOptions || typeof checkboxOptions !== 'object') return false;
            const options = rule.options || {};
            const allKeys = new Set([...Object.keys(options)]);
            for (const key of allKeys) {
                if (options[key] !== checkboxOptions[key]) {
                    return false;
                }
            }
        } else if (rule.kind === 'number') {
            if (rule.value !== schemaValue.value) {
                return false;
            }
        }
    }
    return true;
}

export function getAlertActivationOptions(
    language: "fr" | "en",
    isRfid: boolean
): { value: string; label: string }[] {
    const items = {
        fr: [
            { value: "false", label: "Restrictions désactivées" },
            { value: "true", label: "Restrictions activées" },
            { value: "company", label: "Règles d’entreprise" },
        ],
        en: [
            { value: "false", label: "Restrictions disabled" },
            { value: "true", label: "Restrictions activated" },
            { value: "company", label: "Company rules" },
        ],
    }
    let options = items[language];
    if (!isRfid) {
        options = options.filter(option => option.value !== "company");
    }
    return options;
}

export const updateRuleSchema = (
    schema: typeof RuleSchema,
    backend: BackendSchema | null | undefined
): typeof RuleSchema => {
    if (!backend || !backend.rules) {
        return schema;
    }
    if (Object.values(backend.rules).every(v => v === null)) {
        return GetRuleCompany
    } else {
        return Object.entries(backend.rules).reduce(
            (acc, [ruleType, value]) => {
                const key = ruleType as RuleType

                const isCheckboxType =
                    key in
                    {
                        [RuleType.DOWBlocked]: 1,
                        [RuleType.HoursBlocked]: 1,
                    }

                if (!isCheckboxType && Object.keys(value || {}).length === 0) {
                    return {
                        ...acc,
                        [key]: {
                            value: null,
                        },
                    }
                }

                return {
                    ...acc,
                    [key]: {
                        ...acc[key],
                        ...(value || {}),
                    },
                }
            },
            { ...schema }
        )
    }
}

export const transformRulesToBackendSchema = (rules: Rule[]): BackendSchema => {
    const result: BackendSchema = {
        rules: {
            [RuleType.DOWBlocked]: null,
            [RuleType.HoursBlocked]: null,
            [RuleType.MaxRechargeDurationOptions]: null,
            [RuleType.MaxRechargeEnergyOptions]: null,
        },
    }

    rules.forEach(rule => {
        if (rule.kind === "checkbox" && rule.options) {
            result.rules[rule.type as RuleType.DOWBlocked | RuleType.HoursBlocked] = {
                ...rule.options
            };
        } else if (rule.kind === "number") {
            result.rules[
                rule.type as
                    | RuleType.MaxRechargeDurationOptions
                    | RuleType.MaxRechargeEnergyOptions
                ] = { value: rule.value ?? null };
        }
    });

    return result;
}


export enum AlertType {
    DOWAlert = "DOWAlert",
    HoursAlert = "HoursAlert",
    MaxDuration = "MaxDurationAlert",
    MaxKWH = "MaxKWHAlert"
}

export enum IsActive {
    TRUE = "true",
    FALSE = "false",
    COMPANY = "company"
}